import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import ArcticIconFont from "@/icon";
import styles from "./index.module.less";

function PolygonFormItem({ value, onChange }) {
  const { t } = useTranslation();
  const polygonHandler = useCallback(() => {
    onChange?.({ drawing: "polygon" });
  }, [onChange]);
  const resetPolygonDrawing = useCallback(() => {
    onChange?.({ drawing: undefined, polygon: undefined });
  }, [onChange]);
  if (!value) return null;
  const { polygon, drawing } = value;
  return (
    <div className={styles.polygonFormItem}>
      <div className={polygon ? "marker-setting validated" : "marker-setting"}>
        <ArcticIconFont type="icon-draw-polygon" />
      </div>
      {drawing === "polygon" ? (
        <div className="label-setting" onClick={resetPolygonDrawing}>
          [{t("cancel")}]
        </div>
      ) : (
        <div className="label-setting" onClick={polygonHandler}>
          [{t("setting")}]
        </div>
      )}
    </div>
  );
}

export default PolygonFormItem;
